import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useMemo } from 'react';
import { useIntl } from 'react-intl-next';
import { useSharedPluginState } from '@atlaskit/editor-common/hooks';
import { createItems } from '../ToolbarInsertBlock/create-items';
export var useInsertMenuRailItems = function useInsertMenuRailItems(editorView, options, api) {
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var _useSharedPluginState = useSharedPluginState(api, ['hyperlink', 'date', 'imageUpload', 'mention', 'emoji', 'blockType', 'media', 'typeAhead', 'placeholderText']),
    dateState = _useSharedPluginState.dateState,
    hyperlinkState = _useSharedPluginState.hyperlinkState,
    imageUploadState = _useSharedPluginState.imageUploadState,
    mentionState = _useSharedPluginState.mentionState,
    emojiState = _useSharedPluginState.emojiState,
    blockTypeState = _useSharedPluginState.blockTypeState,
    mediaState = _useSharedPluginState.mediaState,
    typeAheadState = _useSharedPluginState.typeAheadState,
    placeholderTextState = _useSharedPluginState.placeholderTextState;
  var _useMemo = useMemo(function () {
      var _ref;
      return createItems({
        isTypeAheadAllowed: Boolean(typeAheadState === null || typeAheadState === void 0 ? void 0 : typeAheadState.isAllowed),
        tableSupported: !!editorView.state.schema.nodes.table,
        tableSelectorSupported: options.tableSelectorSupported && !!editorView.state.schema.nodes.table,
        mediaUploadsEnabled: (_ref = mediaState && mediaState.allowsUploads) !== null && _ref !== void 0 ? _ref : undefined,
        mediaSupported: !!mediaState,
        imageUploadSupported: !!(api !== null && api !== void 0 && api.imageUpload),
        imageUploadEnabled: imageUploadState === null || imageUploadState === void 0 ? void 0 : imageUploadState.enabled,
        mentionsSupported: !!(mentionState && mentionState.mentionProvider),
        mentionsDisabled: !!(mentionState && !mentionState.canInsertMention),
        actionSupported: !!editorView.state.schema.nodes.taskItem,
        decisionSupported: !!editorView.state.schema.nodes.decisionItem,
        linkSupported: !!hyperlinkState,
        linkDisabled: !hyperlinkState || !hyperlinkState.canInsertLink || !!hyperlinkState.activeLinkMark,
        emojiDisabled: !emojiState || !emojiState.emojiProvider,
        nativeStatusSupported: options.nativeStatusSupported,
        dateEnabled: !!dateState,
        placeholderTextEnabled: placeholderTextState && placeholderTextState.allowInserting,
        horizontalRuleEnabled: options.horizontalRuleEnabled,
        layoutSectionEnabled: Boolean(api === null || api === void 0 ? void 0 : api.layout),
        expandEnabled: !!options.allowExpand,
        showElementBrowserLink: options.showElementBrowserLink,
        emojiProvider: emojiState === null || emojiState === void 0 ? void 0 : emojiState.emojiProvider,
        availableWrapperBlockTypes: blockTypeState && blockTypeState.availableWrapperBlockTypes,
        insertMenuItems: options.insertMenuItems,
        schema: editorView.state.schema,
        numberOfButtons: 10,
        formatMessage: formatMessage,
        isNewMenuEnabled: true
      });
    }, [api === null || api === void 0 ? void 0 : api.imageUpload, api === null || api === void 0 ? void 0 : api.layout, blockTypeState, dateState, editorView.state.schema, emojiState, formatMessage, hyperlinkState, imageUploadState === null || imageUploadState === void 0 ? void 0 : imageUploadState.enabled, mediaState, mentionState, options.allowExpand, options.horizontalRuleEnabled, options.insertMenuItems, options.nativeStatusSupported, options.showElementBrowserLink, options.tableSelectorSupported, placeholderTextState, typeAheadState === null || typeAheadState === void 0 ? void 0 : typeAheadState.isAllowed]),
    _useMemo2 = _slicedToArray(_useMemo, 2),
    _ = _useMemo2[0],
    dropdownItems = _useMemo2[1];
  return dropdownItems;
};